import React from 'react'
import { useFormikContext } from 'formik'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { RichTextEditor } from '../RichTextEditor'

interface Props<T> {
  name: keyof T
  label?: string
  readOnly?: boolean
}

export const FormikRichTextEditor = <T extends unknown>({ name, label, readOnly }: Props<T>) => {
  const { values, setFieldValue } = useFormikContext<T>()

  const handleChange = (html: string) => {
    setFieldValue(name as string, html)
  }

  return (
    <div>
      {label ? (
        // Same label as BasicTextField, so the editor lines up with the text fields around it.
        <Typography variant="h6" css={tw`mb-1 text-shades-400`}>
          {label}
        </Typography>
      ) : null}
      <RichTextEditor
        value={values[name] as unknown as string}
        onChange={handleChange}
        readOnly={readOnly}
      />
    </div>
  )
}
